import http from "../http-common";
import authHeader from "./authHeader";
import { ACTIVITY_API } from "../api";
const getAllActivities = () => {
  return http.get(`${ACTIVITY_API}`, { headers: authHeader() });
};
const getAllActivitiesOfEmployee = (id) => {
  return http.get(`${ACTIVITY_API}/emp/${id}`, { headers: authHeader() });
};
const getAllActivitiesOfCustomer = (id) => {
  return http.get(`${ACTIVITY_API}/customer/${id}`, { headers: authHeader() });
};

// const getRoleById = (id) => {
//   return http.get(`${ACTIVITY_API}/${id}`, { headers: authHeader() });
// };

// const createRole = (data) => {
//   return http.post(`${ACTIVITY_API}`, data, { headers: authHeader() });
// };
// const resignRole = (id) => {
//   return http.put(`${ACTIVITY_API}/${id}`, { role: null }, { headers: authHeader() });
// };
// const updateRole = (id, data) => {
//   return http.put(`${ACTIVITY_API}/${id}`, data, { headers: authHeader() });
// };

// const removeRole = (id) => {
//   return http.delete(`${ACTIVITY_API}/${id}`, { headers: authHeader() });
// };

const RoleService = {
  getAllActivities,
  getAllActivitiesOfEmployee,
  getAllActivitiesOfCustomer,
  // getRoleById,
  // createRole,
  // updateRole,
  // removeRole,
  // resignRole,
};

export default RoleService;
